var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_963_1057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0581 11.9419C11.3021 12.186 11.6979 12.186 11.9419 11.9419C12.186 11.6979 12.186 11.3021 11.9419 11.0581L11.5 11.5L11.0581 11.9419ZM9.55882 5.02941H8.93382C8.93382 7.18576 7.18576 8.93382 5.02941 8.93382V9.55882V10.1838C7.87611 10.1838 10.1838 7.87611 10.1838 5.02941H9.55882ZM5.02941 9.55882V8.93382C2.87306 8.93382 1.125 7.18576 1.125 5.02941H0.5H-0.125C-0.125 7.87611 2.18271 10.1838 5.02941 10.1838V9.55882ZM0.5 5.02941H1.125C1.125 2.87306 2.87306 1.125 5.02941 1.125V0.5V-0.125C2.18271 -0.125 -0.125 2.18271 -0.125 5.02941H0.5ZM5.02941 0.5V1.125C7.18576 1.125 8.93382 2.87306 8.93382 5.02941H9.55882H10.1838C10.1838 2.18271 7.87611 -0.125 5.02941 -0.125V0.5ZM8.26471 8.26471L7.82276 8.70665L11.0581 11.9419L11.5 11.5L11.9419 11.0581L8.70665 7.82276L8.26471 8.26471Z",
    fill: "#64748B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_963_1057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default ForwardRef;